import { render, staticRenderFns } from "./Partner-add-or-update.vue?vue&type=template&id=0fe65edc&scoped=true&"
import script from "./Partner-add-or-update.vue?vue&type=script&lang=js&"
export * from "./Partner-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe65edc",
  null
  
)

export default component.exports